import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Inreview(state = initialState, action) {
  switch (action.type) {
    case userConstants.INREVIEW_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.INREVIEW_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.INREVIEW_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}